module.exports = __webpack_public_path__ + "assets/2c10c11bdbb7e77c403090e59c24ff14.mp3";